import store from '../store/store';
import { clearToken } from '../actions/token-actions';

export const logout = () => {
  store.dispatch(clearToken());
  window.location.replace('/');
};
